import React, { useEffect, useRef, useState } from "react";
import { useGLTF, Html } from "@react-three/drei";
import * as THREE from 'three'
import useVars from "../Stores/useVars";

// import BuildMenu from './50-BuildMenu.jsx'

export default function Model(props) {
  const { nodes, materials } = useGLTF("/buttons/40-AddButton.glb");

  const plotRef = useRef()
  const buyTagRef = useRef()

  let hoverColor = new THREE.Color(0x00eeff)
  let defaultColor = new THREE.Color(0xcceeff)
  let disableColor = new THREE.Color(0xffffff)

  const addButtonMat = new THREE.MeshBasicMaterial({color: defaultColor})

  const varsState = useVars()

  const buyAudio = new Audio('audio/01-pop.mp3')
  const failAudio = new Audio('audio/05-click.mp3')
  const buildAudio = new Audio('audio/04-build.mp3')

  buyAudio.volume = .15
  failAudio.volume = .15
  buildAudio.volume = .15

  const [buildMenuShown, setBuildMenuShown] = useState(false)
  const [buyTagShown, setBuyTagShown] = useState(false)
  const [cardsViewable, setCardsViewable] = useState([false,false,false,false,false,false,false,false,false,false,false,false])

  function AddBuilding() {
    if(varsState.phase == 'scrolling' && varsState.money >= varsState.nextCost)
    {
      varsState.startBuying()
      let plotX = 3 + props.position[0] / 2.5
      let plotY = 3 + props.position[2] / 2.5
      varsState.setPlotCoords([plotX,plotY])
      const fee = varsState.nextCost * -1
      varsState.addMoney(fee)
      varsState.setNextCost(varsState.nextCost + 5)
      setBuildMenuShown(true)
      RandomizeCards()
      buyAudio.play()
    }
    else if(varsState.phase == 'scrolling' && varsState.money < varsState.nextCost)
    {
      failAudio.play()
    }
  }
  
  function Hover() {
    if(buyTagRef.current)
    {
      if(varsState.money > varsState.nextCost)
      {
        buyTagRef.current.style.backgroundColor = '#10730E'
      }
      else
      {
        buyTagRef.current.style.backgroundColor = '#aaaaaa'
      }
    }
    addButtonMat.color = hoverColor
    document.body.style.cursor = 'pointer'
    setBuyTagShown(true)
  }

  function EndHover() {
    // addButtonMat.color = defaultColor
    document.body.style.cursor = 'default'
    setBuyTagShown(false)
  }

  /**
   * THE ACTUAL ADD BUTTON RETURN METHOD
   */
  return (
    <group {...props} dispose={null} 
    ref={plotRef}
    onPointerEnter={Hover} 
    onPointerOut={EndHover}
    
    position={[0,-.1,0]}
    >
      {/* <Html center>
        <div style={{pointerEvents: 'none', backgroundColor: 'green', color: 'white'}}>
          Build: {varsState.nextCost}
        </div>
      </Html> */}
      <mesh rotation={[-Math.PI / 2, 0, 0]} scale={1.85} onClick={AddBuilding}>
        <planeGeometry />
        <meshStandardMaterial />
      </mesh>
      <mesh
        geometry={nodes.Cube108.geometry}
        material={addButtonMat}
      />
      <mesh
        geometry={nodes.Cube109.geometry}
        material={addButtonMat}
      />
      {buildMenuShown && varsState.phase == 'buying' ? <BuildMenu /> : <></>}
      {buyTagShown && varsState.phase == 'scrolling' ? <BuyTag /> : <></>}
    </group>
  );


  function BuyTag() {
    return <>
      <Html center position={[0,.6,0]}>
        <div 
          className="buy-tag"
          ref={buyTagRef}
          style={{backgroundColor: '#10730E'}}
        >
          Buy: -${varsState.nextCost}
        </div>
      </Html>
    </>
  }

  function RerollButton() {
    if(varsState.money >= 10)
    {
      varsState.addMoney(-10)
      RandomizeCards()
    }
  }

  function RandomizeCards() {
    for(let i = 0; i < 12; i++)
        {
            cardsViewable[i] = false
        }
    for(let i = 0; i < 3; i++)
    {
        let cardSelection = Math.trunc(Math.random() * 12)
        if(cardsViewable[cardSelection] == false)
        {
            let tempArray = cardsViewable
            tempArray[cardSelection] = true
            // cardsViewable[cardSelection] = true
            setCardsViewable(tempArray)
        }
        else
            i--
    }
}
  
  function BuildMenu() {

    return <>
      <Html center 
      position={[0,.2,0]}
      >
        <div className="buy-menu-2">
          <div className="title">Select a development</div>
          <div className="cards-holder">
            <Card 
              id={0}
              category={"Nature"}
              title={"Forest"}
              description={""}
              salary={"5"}
              icon={"icons/07-nature.svg"}
              image={"thumbnails/00-forest.jpg"}
              shown={true}
            />
            <Card 
                id={1}
                category={"Nature"}
                title={"Pond"}
                description={[
                    <div style={{color: 'green', fontWeight: '700'}}>+2</div>,
                    <img src="icons/17-salary-green.svg"/>,
                    "/ adjacent empty space"
                ]}
                salary={"3"}
                icon={"icons/07-nature.svg"}
                image={"thumbnails/01-pond.jpg"}
                shown={false}
            />
            <Card 
                id={2}
                category={"Nature"}
                title={"Garden"}
                description={""}
                salary={"5"}
                icon={"icons/07-nature.svg"}
                image={"thumbnails/02-garden.jpg"}
                shown={false}
            />
            <Card 
                id={3}
                category={"Industrial"}
                title={"Factory"}
                description={[
                    <div style={{color: 'green', fontWeight: '700'}}>+10</div>,
                    <img src="icons/17-salary-green.svg"/>,
                    "if",
                    <img src="icons/02-buildings.svg" />,
                    ">",
                    <img src="icons/03-population.svg" />
                ]}
                salary={"2"}
                icon={"icons/08-industrial.svg"}
                image={"thumbnails/03-factory.jpg"}
                shown={false}
            />
            <Card 
                id={4}
                category={"Industrial"}
                title={"Lumberyard"}
                description={[
                    <div style={{color: 'green', fontWeight: '700'}}>+12</div>,
                    <img src="icons/17-salary-green.svg"/>,
                    "/ adjacent",
                    <div style={{color: '#69BF12', fontWeight: '700'}}>Forest</div>,
                ]}
                salary={"2"}
                icon={"icons/08-industrial.svg"}
                image={"thumbnails/04-lumberyard.jpg"}
                shown={false}
            />
            <Card 
                id={5}
                category={"Industrial"}
                title={"Power Plant"}
                description={[
                    <div style={{color: 'green', fontWeight: '700'}}>+6</div>,
                    <img src="icons/17-salary-green.svg"/>,
                    "/ adjacent",
                    <img src="icons/13-industrial-blue.svg"/>
                ]}
                salary={"2"}
                icon={"icons/08-industrial.svg"}
                image={"thumbnails/05-powerplant.jpg"}
                shown={false}
            />
            <Card 
                id={6}
                category={"Residential"}
                title={"Apartments"}
                description={[
                    <div style={{color: '#C46C3A', fontWeight: '700'}}>-5</div>,
                    <img src="icons/03-population.svg"/>,
                    "/ adjacent",
                    <img src="icons/13-industrial-blue.svg"/>
                ]}
                salary={"15"}
                icon={"icons/09-residential.svg"}
                image={"thumbnails/06-apartment.jpg"}
                shown={false}
            />
            <Card 
                id={7}
                category={"Residential"}
                title={"Townhouses"}
                description={""}
                salary={"10"}
                icon={"icons/09-residential.svg"}
                image={"thumbnails/07-townhouses.jpg"}
                shown={true}
            />
            <Card 
                id={8}
                category={"Residential"}
                title={"Houses"}
                description={[
                    <div style={{color: '#C46C3A', fontWeight: '700'}}>+5</div>,
                    <img src="icons/03-population.svg"/>,
                    "/ adjacent",
                    <img src="icons/14-residential-red.svg"/>
                ]}
                salary={"5"}
                icon={"icons/09-residential.svg"}
                image={"thumbnails/08-houses.jpg"}
                shown={false}
            />
            <Card 
                id={9}
                category={"Entertainment"}
                title={"Theater"}
                description={[
                    <div style={{color: 'green', fontWeight: '700'}}>+5</div>,
                    <img src="icons/17-salary-green.svg"/>,
                    "/ adjacent",
                    <img src="icons/14-residential-red.svg"/>
                ]}
                salary={"1"}
                icon={"icons/10-entertainment.svg"}
                image={"thumbnails/09-theater.jpg"}
                shown={false}
            />
            <Card 
                id={10}
                category={"Entertainment"}
                title={"Restaurant"}
                description={[
                    <div style={{color: 'green', fontWeight: '700'}}>+1</div>,
                    <img src="icons/17-salary-green.svg"/>,
                    "/",
                    <div style={{color: '#C46C3A', fontWeight: '700'}}>5</div>,
                    <img src="icons/03-population.svg"/>
                ]}
                salary={"1"}
                icon={"icons/10-entertainment.svg"}
                image={"thumbnails/10-restaurant.jpg"}
                shown={false}
            />
            <Card 
                id={11}
                category={"Entertainment"}
                title={"Museum"}
                description={[
                    <div style={{color: 'green', fontWeight: '700'}}>+1</div>,
                    <img src="icons/17-salary-green.svg"/>,
                    "/",
                    <div style={{color: '#C46C3A', fontWeight: '700'}}>2</div>,
                    <img src="icons/02-buildings.svg"/>
                ]}
                salary={"1"}
                icon={"icons/10-entertainment.svg"}
                image={"thumbnails/11-museum.jpg"}
                shown={false}
            />
          </div>
          <button onClick={RerollButton}>Reroll: 10</button>
        </div>
      </Html>
    </>
  }

  function Card(props) {
    const cardId = props.id
    const icon = props.icon
    const title = props.title
    const thumbnail = props.image
    const effect = props.description
    const salary = props.salary

    const shown = cardsViewable[cardId]

    const colors = ["#69BF12", "#3A79C4", "#C46C3A", "#C43AB6", "#C43A3A"]
    const colorNum = Math.trunc(cardId / 3)

    function BuyPlot() {
      varsState.setPurchasedPlot(cardId)
      varsState.endBuying()
      varsState.addPlot()
      buildAudio.play()
    }
  
    return <div className="card" onClick={BuyPlot} style={shown ? {borderColor: colors[colorNum]} : {display:  'none'}}>
      <div className="card-header" style={{backgroundColor: colors[colorNum]}}>
        <img src={icon} />
        {title}
      </div>
      <div className="card-image">
        <img src={thumbnail} style={{width: '87%'}} />
      </div>
      <div className="card-effect">
        {effect}
      </div>
      <div className="salary" style={cardId > 5 && cardId < 9 ? {backgroundColor: '#C8791D'} : {backgroundColor: '#10730E'}}>
        +{salary}
        {cardId < 6 || cardId > 8 ? <img src="icons/16-salary.svg" style={{width: 16}} /> : null}
        {cardId > 5 && cardId < 9 ? <img src="icons/15-population-white.svg" style={{width: 20}} /> : null}
      </div>
    </div>

    }
}

// useGLTF.preload("/buttons/40-AddButton.glb");
